import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/productPage.vue';
import ShowcaseView from '@/views/ShowcaseView.vue';
import MWCCarouselView from '@/views/MWCCarouselView.vue';
import EricssonSiliconView from "@/views/EricssonSiliconView.vue";
import PortfolioView from '@/views/PortfolioView';
import { CustomSelectionEditView, CustomSelectionProjectsView } from '@/views';
import Callback from '@/views/Callback'
import readIsManaVersionFlag from '@/shared/manaVersionHelper';
import { SECTIONS, GENERAL, PRODUCT_FAMILIES, PRODUCT_FAMILIES_MANA } from '@/constants/routes';
import { authService} from '@/services/security'
import isOnline from 'is-online';
import MainPageComponent from '../views/MainPageComponent.vue';
import ProductPreviewComponent from '../components/complex.component/ProductPreviewComponent.vue';
import { ROLES } from '@/constants/roles';
import SilentRenew from '@/views/SilentRenew.vue';
import PageView from '@/views/PageView.vue';

const isMANAVersion = readIsManaVersionFlag();

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'radio',
    props: {
      productTreeView: GENERAL.productFamilyTree.prefix
    },
    component: Home
  },
  {
    path: '/' + GENERAL.productFamilyTree.prefix,
    component: () => import('@/views/' + GENERAL.productFamilyTree.fileName),
    props: {
      familyImagePath: GENERAL.productFamilyTree.treeImageFileName,
      name: GENERAL.productFamilyTree.name
    }
  },
  {
    path: '/' + GENERAL.callback,
    name: GENERAL.callback,
    component: Callback
  },
  {
    path: '/' + GENERAL.silentRenew,
    name: GENERAL.silentRenew,
    component: SilentRenew
  }
];

routes.push({
  path: '/showcase',
  name: 'showcase',
  component: ShowcaseView
});

routes.push({
  path: '/admin',
  name: 'admin',
  component: MainPageComponent
});

routes.push({
  path: '/mwc',
  name: 'mwc',
  component: MWCCarouselView
});

routes.push({
  path: '/silicon',
  name: 'silicon',
  component: EricssonSiliconView
});

routes.push({
  path: '/portfolio',
  name: 'portfolio',
  props: {},
  component: PortfolioView
});

routes.push({
  path: '/preview',
  name: 'preview',
  props: true,
  component: ProductPreviewComponent
});

routes.push({
  path: '/page/:pageId',
  name: 'page',
  component: PageView
});

SECTIONS.forEach(section => {
  routes.push({
    path: '/' + section.prefix,
    name: section.name,
    props: {
      section,
      general: GENERAL,
      images: isMANAVersion ? PRODUCT_FAMILIES_MANA[section.prefix] : PRODUCT_FAMILIES[section.prefix]
    },
    component: () => import('@/views/' + GENERAL.productFamilyFileName)
  });

  routes.push({
    path: '/' + section.prefix + ':product',
    name: section.prefix,
    props: {
      section: {
        ...section
      },
      prefix: section.prefix
    },
    component: () => import('@/views/' + GENERAL.singleProductFileName)
  });

  routes.push({
    path: '/' + section.prefix + ':product/:subproduct',
    name: section.prefix + 'subproduct',
    props: {
      section: {
        ...section
      },
      prefix: section.prefix
    },
    component: () => import('@/views/' + GENERAL.singleProductFileName)
  });
})

routes.push({
  path: '/custom-selection/',
  name: 'custom-selection-create',
  component: CustomSelectionEditView
});

routes.push({
  path: '/custom-selection/edit/:projectNumber',
  name: 'custom-selection-edit',
  component: CustomSelectionEditView
});

routes.push({
  path: '/custom-selection/projects',
  name: 'custom-selection-projects',
  component: CustomSelectionProjectsView
});

const router = new VueRouter({
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  base: GENERAL.prefix,
  routes
});

router.beforeEach(async (to, from, next) => {
  const isAdmin = await authService.hasPermission(ROLES.ADMIN);
  isOnline().then(online => {
    if(!online){
      next();
      return;
    }
    authService.isUserLoggedIn().then(isLoggedIn => {
      if (isLoggedIn || to.path === '/' + GENERAL.callback) {
        if(to.name === 'admin' && !isAdmin) {
          next('/');
        }
        next();
      } else {
        if(window.location.pathname !== to.path){
          next(window.location.pathname);
        } else {
          authService.login(to.path);
        }
      }
    });
  });
  
});

export default router;
